// GENERATED FILE - DO NOT MODIFY
export enum ReceiptOfGoodsStatus {
    Active = "0",
    Complete = "1",
    Close = "C",
}

export let nameof = "ReceiptOfGoodsStatus";
